<template>
  <div class="flex items-center justify-center bg-block-2 w-full rounded-md text-sm">
    <button
      v-for="(tab,index) in tabs"
      :key="index"
      class="p-4 text-white flex items-center justify-center w-full"
      :class="{
        'button-primary': tab.value == modelValue,
        'rounded-l-md': tab.value == 'buy',
        'rounded-r-md': tab.value == 'sell'
      }"
      @click="mutableValue = tab.value"
    >
      {{ tab.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SwapTab",
  props: {
    modelValue: {
      type: String
    }
  },
  data() {
    return {
      tabs: [
        {
          name: "Buy HLP",
          value: "buy"
        },
        {
          name: "Sell HLP",
          value: "sell"
        }
      ]
    }
  },
  computed: {
    mutableValue: {
      get() {
        return this.modelValue;
      },

      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },
  }
}
</script>